/*!

@sean HELLO THIS IS A HACKY CUSTOM BUILD BTW

Waypoints Infinite Scroll Shortcut - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blog/master/licenses.txt
*/

(function() {
  'use strict'

  var $ = window.jQuery
  var Waypoint = window.Waypoint

  /* http://imakewebthings.com/waypoints/shortcuts/infinite-scroll */
  function Infinite(options) {
    this.options = $.extend({}, Infinite.defaults, options)
    this.container = this.options.element
    if (this.options.container !== 'auto') {
      this.container = this.options.container
    }
    this.$container = $(this.container)
    this.$more = $(this.options.more)

    if (this.$more.length) {
      this.setupHandler()
      this.waypoint = new Waypoint(this.options)
    }
  }

  /**
   * @sean Adding this method to get callbacks at various load points
   *       (specifically every fetch + final fetch)
   */
  Infinite.prototype.fetchAll = function (nextCb, doneCb) {
    var self = this
    var handler = this.options.handler
    this.options.onAfterPageLoad = function ($items) {
     	console.log('onAfterPageLoad', $items && $items.length) 
    }
    next()

    function next (done, $data) {
      if ($data) {
         nextCb && nextCb($data)
      }
      if (done) {
        self._prefetched = true
        doneCb && doneCb()
      } else {
        handler(next)
      }
    }
  }

  /* Private */
  Infinite.prototype.setupHandler = function() {
    this.options.handler = $.proxy(function(cb) {
      this.options.onBeforePageLoad()
      this.destroy()
      this.$container.addClass(this.options.loadingClass)
      var href = $(this.options.more).attr('href')
      console.log('Infinite scroll setting up handler')

      $.get($(this.options.more).attr('href'), $.proxy(function(data) {
        if (this._prefetched) return
        console.log('Infinite scroll fetched more!')
        var $data = $('<html></html>').append($($.parseHTML(data)))
        var $newMore = $data.find(this.options.more)
        console.log('Infinite scroll fetched next at', href)

        var $items = $data.find(this.options.items)
        if (!$items.length) {
          $items = $data.filter(this.options.items)
        }

        this.$container.append($items)
        this.$container.removeClass(this.options.loadingClass)

        if (!$newMore.length) {
          $newMore = $data.filter(this.options.more)
        }
        if ($newMore.length) {
          console.log('Infinite scroll will fetch even more...')
          this.$more.replaceWith($newMore)
          this.$more = $newMore
          this.waypoint = new Waypoint(this.options)
          if (cb && typeof cb === 'function') {
            setTimeout(function () {
              cb(false, $data)
            })
          }
        }
        else {
          this.$more.remove()
          if (cb && typeof cb === 'function') {
            setTimeout(function () {
              cb(true, $data)
            })
          }
        }

        this.options.onAfterPageLoad($items)
      }, this))
    }, this)
  }

  /* Public */
  Infinite.prototype.destroy = function() {
    if (this.waypoint) {
      this.waypoint.destroy()
    }
  }

  Infinite.defaults = {
    container: 'auto',
    items: '.infinite-item',
    more: '.infinite-more-link',
    offset: 'bottom-in-view',
    loadingClass: 'infinite-loading',
    onBeforePageLoad: $.noop,
    onAfterPageLoad: $.noop
  }

  Waypoint.Infinite = Infinite
}())
;
